module.exports = __webpack_public_path__ + "static/media/card4.59004c0d.png";